<template>
  <div class="rating-container">
    <div :class="`rating-header ${borderBtm}`">
      <p class="fs-16 fw-700">{{ heading }}</p>
      <p class="fs-11 color-slaty">{{ subHeading }}</p>
    </div>
    <div v-for="(item, index) in visibleItems" :key="index" class="w100">
      <div class="rating-item">
        <div class="rating-item-left">
          <p class="fs-16 fw-700">{{ item?.properties?.title }}</p>
          <star-rating
            :tooltip="false"
            :selectedRating="
              getSelectedRating(
                category,
                item?.properties?.productId,
                item?.id?.ratingType
              )
            "
            @starClick="
              (rating) =>
                handleRatingSelection(
                  rating,
                  category,
                  item?.properties?.productId,
                  items?.ratings?.[rating]?.tags,
                  item?.properties?.menuCode,
                  item?.properties?.title,
                  item?.id?.ratingType
                )
            "
          ></star-rating>
        </div>
        <img
          :src="getImage(item?.properties?.imageUrl)"
          alt="img"
          @error="handleImageError"
          class="rating-item-image"
        />
      </div>
      <div
        v-if="
          getSelectedRating(
            category,
            item?.properties?.productId,
            item?.id?.ratingType
          )
        "
      >
        <p class="fs-12 mb4">
          {{
            item?.ratings?.[
              getSelectedRating(
                category,
                item?.properties?.productId,
                item?.id?.ratingType
              )
            ]?.title
          }}
        </p>
        <div class="cards-holder gap6">
          <div
            class="rating-tag"
            v-for="(tag, i) in item?.ratings?.[
              getSelectedRating(
                category,
                item?.properties?.productId,
                item?.id?.ratingType
              )
            ]?.tags"
            :key="i"
            :class="{
              'selected-rating-tag': isSelectedTag(
                tag,
                category,
                item?.properties?.productId,
                item?.id?.ratingType
              ),
            }"
            @click="
              () =>
                handleTagSelection(
                  tag,
                  category,
                  item?.properties?.productId,
                  item?.id?.ratingType
                )
            "
          >
            {{ tag }}
          </div>
        </div>
      </div>
    </div>

    <button
      v-if="dataItem?.subCategories?.length > defaultExpandValue && !isExpanded"
      @click="toggleExpand"
      class="expand-button-rating"
    >
      View All
      <i class="hkfi-arrow-line transform-90 mr15 hand"></i>
    </button>
  </div>
</template>
<script>
import { staticImgBaseUrl, csatApiBaseUrl } from "../../config/apiEndpoints";
import StarRating from "./StarRating.vue";
import { keyMapsMutation } from "../../helpers/storeKeys";
export default {
  name: "RatingCard",
  props: {
    dataItem: { required: true, default: {} },
    heading: { required: false, default: "" },
    subHeading: { required: false, default: "" },
    borderBtm: { required: false, default: "" },
    category: { required: false, default: "" },
  },
  data() {
    return {
      isExpanded: false,
      csatApiBaseUrl,
      staticImgBaseUrl,
    };
  },
  components: { StarRating },
  mounted() {},
  methods: {
    handleImageError(event) {
      event.target.src = staticImgBaseUrl + "/images/global/ratingItemImg.svg";
      event.target.onerror = null;
    },
    getImage(url) {
      return url
        ? url.includes("http")
          ? url
          : csatApiBaseUrl + url
        : this.getPlaceHolderImg;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    handleRatingSelection(
      rating,
      type,
      productId = "",
      tags = [],
      menuCode,
      productName = "",
      ratingType
    ) {
      switch (type) {
        case "FOOD":
          this.$store.commit(keyMapsMutation.UPDATE_FOOD_RATING, {
            rating,
            productId,
            tags,
            ratedTags: [],
            menuCode,
            productName,
          });

          break;
        case "DELIVERY":
          this.$store.commit(keyMapsMutation.UPDATE_DELIVERY_RATING, {
            rating,
            tags,
            ratedTags: [],
            ratingType: ratingType,
          });

          break;
        case "MONEY_VALUE":
          this.$store.commit(keyMapsMutation.UPDATE_VALUE_FOR_MONEY_RATING, {
            rating,
            tags,
            ratedTags: [],
            ratingType: ratingType,
          });
          break;
        default:
          break;
      }
    },
    handleTagSelection(clickedTag, type, productId, ratingType) {
      switch (type) {
        case "FOOD": {
          const index = this.food.findIndex(
            (item) => item.productId === productId
          );
          if (index !== -1) {
            const item = this.food[index];
            const tagIndex = item.ratedTags.indexOf(clickedTag);
            if (tagIndex !== -1) {
              item.ratedTags.splice(tagIndex, 1);
            } else {
              item.ratedTags.push(clickedTag);
            }
            this.$store.commit(keyMapsMutation.UPDATE_FOOD_RATING, item);
          }
          break;
        }
        case "DELIVERY": {
          const index = this.delivery.findIndex(
            (item) => item.ratingType === ratingType
          );
          if (index !== -1) {
            const item = this.delivery[index];
            const tagIndex = item.ratedTags.indexOf(clickedTag);
            if (tagIndex !== -1) {
              item.ratedTags.splice(tagIndex, 1);
            } else {
              item.ratedTags.push(clickedTag);
            }
            this.$store.commit(keyMapsMutation.UPDATE_DELIVERY_RATING, item);
          }
          break;
        }
        case "MONEY_VALUE": {
          const index = this.valueForMoney.findIndex(
            (item) => item.ratingType === ratingType
          );
          if (index !== -1) {
            const item = this.valueForMoney[index];
            const tagIndex = item.ratedTags.indexOf(clickedTag);
            if (tagIndex !== -1) {
              item.ratedTags.splice(tagIndex, 1);
            } else {
              item.ratedTags.push(clickedTag);
            }
            this.$store.commit(
              keyMapsMutation.UPDATE_VALUE_FOR_MONEY_RATING,
              item
            );
          }
          break;
        }
        default:
          break;
      }
    },
    getSelectedRating(category, productId, ratingType) {
      if (category === "FOOD") {
        const foodItem = this.food?.find(
          (item) => item.productId === productId
        );
        return foodItem ? foodItem.rating : 0;
      } else if (category === "DELIVERY") {
        const deliveryItem = this.delivery?.find(
          (item) => item.ratingType === ratingType
        );
        return deliveryItem ? deliveryItem.rating : 0;
      } else if (category === "MONEY_VALUE") {
        const valueItem = this.valueForMoney?.find(
          (item) => item.ratingType === ratingType
        );
        return valueItem ? valueItem.rating : 0;
      }
      return 0;
    },
    isSelectedTag(tag, category, productId, ratingType) {
      if (category === "FOOD") {
        const item = this.food?.find((item) => item.productId === productId);
        return item ? item.ratedTags.includes(tag) : false;
      } else if (category === "DELIVERY") {
        const item = this.delivery.find(
          (item) => item.ratingType === ratingType
        );
        return item ? item.ratedTags.includes(tag) : false;
      } else if (category === "MONEY_VALUE") {
        const item = this.valueForMoney?.find(
          (item) => item.ratingType === ratingType
        );
        return item ? item.ratedTags.includes(tag) : false;
      }
      return false;
    },
  },
  computed: {
    getPlaceHolderImg() {
      return staticImgBaseUrl + "/images/global/ratingItemImg.svg";
    },
    visibleItems() {
      const items = this.dataItem?.subCategories || [];
      return this.isExpanded ? items : items.slice(0, this.defaultExpandValue);
    },
    defaultExpandValue() {
      return this.dataItem?.defaultExpandValue;
    },
    food() {
      return this.$store.state.CsatFeedback.food;
    },
    delivery() {
      return this.$store.state.CsatFeedback.delivery;
    },
    valueForMoney() {
      return this.$store.state.CsatFeedback.valueForMoney;
    },
  },
};
</script>
